import { useEffect, useMemo, useRef, useState } from "react";
import { DashboardLayout } from "src/components/dashboard";
import { useLazyGetCurrencyDetailsQuery } from "src/store/services/currencyApi";
import ButImg from "../../assets/images/currency/Button.png";
import Downtrend from "../../assets/images/currency/downtrend.png";

type CurrencyOption = {
  code: string;
  name: string;
  flag?: string;
};

// Minimal list for base currency select
const BASE_CURRENCIES: CurrencyOption[] = [
  { code: "NGN", name: "Nigerian Naira", flag: "https://flagcdn.com/ng.svg" },
  { code: "USD", name: "US Dollar", flag: "https://flagcdn.com/us.svg" },
  { code: "EUR", name: "Euro", flag: "https://flagcdn.com/eu.svg" },
  { code: "GBP", name: "British Pound", flag: "https://flagcdn.com/gb.svg" },
  { code: "CAD", name: "Canadian Dollar", flag: "https://flagcdn.com/ca.svg" },
  {
    code: "AUD",
    name: "Australian Dollar",
    flag: "https://flagcdn.com/au.svg",
  },

  // Additional 100 currencies
  { code: "AED", name: "UAE Dirham", flag: "https://flagcdn.com/ae.svg" },
  { code: "AFN", name: "Afghan Afghani", flag: "https://flagcdn.com/af.svg" },
  { code: "ALL", name: "Albanian Lek", flag: "https://flagcdn.com/al.svg" },
  { code: "AMD", name: "Armenian Dram", flag: "https://flagcdn.com/am.svg" },
  { code: "ARS", name: "Argentine Peso", flag: "https://flagcdn.com/ar.svg" },
  {
    code: "AZN",
    name: "Azerbaijani Manat",
    flag: "https://flagcdn.com/az.svg",
  },
  { code: "BDT", name: "Bangladeshi Taka", flag: "https://flagcdn.com/bd.svg" },
  { code: "BGN", name: "Bulgarian Lev", flag: "https://flagcdn.com/bg.svg" },
  { code: "BHD", name: "Bahraini Dinar", flag: "https://flagcdn.com/bh.svg" },
  { code: "BND", name: "Brunei Dollar", flag: "https://flagcdn.com/bn.svg" },
  {
    code: "BOB",
    name: "Bolivian Boliviano",
    flag: "https://flagcdn.com/bo.svg",
  },
  { code: "BRL", name: "Brazilian Real", flag: "https://flagcdn.com/br.svg" },
  { code: "BYN", name: "Belarusian Ruble", flag: "https://flagcdn.com/by.svg" },
  { code: "CHF", name: "Swiss Franc", flag: "https://flagcdn.com/ch.svg" },
  { code: "CLP", name: "Chilean Peso", flag: "https://flagcdn.com/cl.svg" },
  { code: "CNY", name: "Chinese Yuan", flag: "https://flagcdn.com/cn.svg" },
  { code: "COP", name: "Colombian Peso", flag: "https://flagcdn.com/co.svg" },
  {
    code: "CRC",
    name: "Costa Rican Colón",
    flag: "https://flagcdn.com/cr.svg",
  },
  { code: "CZK", name: "Czech Koruna", flag: "https://flagcdn.com/cz.svg" },
  { code: "DKK", name: "Danish Krone", flag: "https://flagcdn.com/dk.svg" },
  { code: "DOP", name: "Dominican Peso", flag: "https://flagcdn.com/do.svg" },
  { code: "EGP", name: "Egyptian Pound", flag: "https://flagcdn.com/eg.svg" },
  { code: "ETB", name: "Ethiopian Birr", flag: "https://flagcdn.com/et.svg" },
  { code: "FJD", name: "Fijian Dollar", flag: "https://flagcdn.com/fj.svg" },
  {
    code: "FKP",
    name: "Falkland Islands Pound",
    flag: "https://flagcdn.com/fk.svg",
  },
  { code: "GEL", name: "Georgian Lari", flag: "https://flagcdn.com/ge.svg" },
  { code: "GHS", name: "Ghanaian Cedi", flag: "https://flagcdn.com/gh.svg" },
  { code: "GIP", name: "Gibraltar Pound", flag: "https://flagcdn.com/gi.svg" },
  {
    code: "GTQ",
    name: "Guatemalan Quetzal",
    flag: "https://flagcdn.com/gt.svg",
  },
  { code: "HKD", name: "Hong Kong Dollar", flag: "https://flagcdn.com/hk.svg" },
  { code: "HNL", name: "Honduran Lempira", flag: "https://flagcdn.com/hn.svg" },
  { code: "HRK", name: "Croatian Kuna", flag: "https://flagcdn.com/hr.svg" },
  { code: "HUF", name: "Hungarian Forint", flag: "https://flagcdn.com/hu.svg" },
  {
    code: "IDR",
    name: "Indonesian Rupiah",
    flag: "https://flagcdn.com/id.svg",
  },
  { code: "ILS", name: "Israeli Shekel", flag: "https://flagcdn.com/il.svg" },
  { code: "INR", name: "Indian Rupee", flag: "https://flagcdn.com/in.svg" },
  { code: "IQD", name: "Iraqi Dinar", flag: "https://flagcdn.com/iq.svg" },
  { code: "ISK", name: "Icelandic Krona", flag: "https://flagcdn.com/is.svg" },
  { code: "JMD", name: "Jamaican Dollar", flag: "https://flagcdn.com/jm.svg" },
  { code: "JPY", name: "Japanese Yen", flag: "https://flagcdn.com/jp.svg" },
  { code: "KES", name: "Kenyan Shilling", flag: "https://flagcdn.com/ke.svg" },
  { code: "KGS", name: "Kyrgyzstani Som", flag: "https://flagcdn.com/kg.svg" },
  { code: "KHR", name: "Cambodian Riel", flag: "https://flagcdn.com/kh.svg" },
  { code: "KRW", name: "South Korean Won", flag: "https://flagcdn.com/kr.svg" },
  { code: "KWD", name: "Kuwaiti Dinar", flag: "https://flagcdn.com/kw.svg" },
  {
    code: "KZT",
    name: "Kazakhstani Tenge",
    flag: "https://flagcdn.com/kz.svg",
  },
  { code: "LAK", name: "Lao Kip", flag: "https://flagcdn.com/la.svg" },
  { code: "LBP", name: "Lebanese Pound", flag: "https://flagcdn.com/lb.svg" },
  { code: "LKR", name: "Sri Lankan Rupee", flag: "https://flagcdn.com/lk.svg" },
  { code: "LYD", name: "Libyan Dinar", flag: "https://flagcdn.com/ly.svg" },
  { code: "MAD", name: "Moroccan Dirham", flag: "https://flagcdn.com/ma.svg" },
  { code: "MDL", name: "Moldovan Leu", flag: "https://flagcdn.com/md.svg" },
  { code: "MKD", name: "Macedonian Denar", flag: "https://flagcdn.com/mk.svg" },
  { code: "MMK", name: "Burmese Kyat", flag: "https://flagcdn.com/mm.svg" },
  { code: "MNT", name: "Mongolian Tugrik", flag: "https://flagcdn.com/mn.svg" },
  { code: "MOP", name: "Macanese Pataca", flag: "https://flagcdn.com/mo.svg" },
  { code: "MUR", name: "Mauritian Rupee", flag: "https://flagcdn.com/mu.svg" },
  { code: "MXN", name: "Mexican Peso", flag: "https://flagcdn.com/mx.svg" },
  {
    code: "MYR",
    name: "Malaysian Ringgit",
    flag: "https://flagcdn.com/my.svg",
  },
  {
    code: "MZN",
    name: "Mozambican Metical",
    flag: "https://flagcdn.com/mz.svg",
  },
  { code: "NAD", name: "Namibian Dollar", flag: "https://flagcdn.com/na.svg" },
  {
    code: "NIO",
    name: "Nicaraguan Córdoba",
    flag: "https://flagcdn.com/ni.svg",
  },
  { code: "NOK", name: "Norwegian Krone", flag: "https://flagcdn.com/no.svg" },
  {
    code: "NZD",
    name: "New Zealand Dollar",
    flag: "https://flagcdn.com/nz.svg",
  },
  { code: "OMR", name: "Omani Rial", flag: "https://flagcdn.com/om.svg" },
  {
    code: "PAB",
    name: "Panamanian Balboa",
    flag: "https://flagcdn.com/pa.svg",
  },
  { code: "PEN", name: "Peruvian Sol", flag: "https://flagcdn.com/pe.svg" },
  {
    code: "PGK",
    name: "Papua New Guinean Kina",
    flag: "https://flagcdn.com/pg.svg",
  },
  { code: "PHP", name: "Philippine Peso", flag: "https://flagcdn.com/ph.svg" },
  { code: "PKR", name: "Pakistani Rupee", flag: "https://flagcdn.com/pk.svg" },
  { code: "PLN", name: "Polish Złoty", flag: "https://flagcdn.com/pl.svg" },
  {
    code: "PYG",
    name: "Paraguayan Guaraní",
    flag: "https://flagcdn.com/py.svg",
  },
  { code: "QAR", name: "Qatari Riyal", flag: "https://flagcdn.com/qa.svg" },
  { code: "RON", name: "Romanian Leu", flag: "https://flagcdn.com/ro.svg" },
  { code: "RSD", name: "Serbian Dinar", flag: "https://flagcdn.com/rs.svg" },
  { code: "RUB", name: "Russian Ruble", flag: "https://flagcdn.com/ru.svg" },
  { code: "SAR", name: "Saudi Riyal", flag: "https://flagcdn.com/sa.svg" },
  { code: "SEK", name: "Swedish Krona", flag: "https://flagcdn.com/se.svg" },
  { code: "SGD", name: "Singapore Dollar", flag: "https://flagcdn.com/sg.svg" },
  {
    code: "SLL",
    name: "Sierra Leonean Leone",
    flag: "https://flagcdn.com/sl.svg",
  },
  { code: "SOS", name: "Somali Shilling", flag: "https://flagcdn.com/so.svg" },
  {
    code: "SRD",
    name: "Surinamese Dollar",
    flag: "https://flagcdn.com/sr.svg",
  },
  { code: "THB", name: "Thai Baht", flag: "https://flagcdn.com/th.svg" },
  { code: "TND", name: "Tunisian Dinar", flag: "https://flagcdn.com/tn.svg" },
  { code: "TRY", name: "Turkish Lira", flag: "https://flagcdn.com/tr.svg" },
  {
    code: "TWD",
    name: "New Taiwan Dollar",
    flag: "https://flagcdn.com/tw.svg",
  },
  {
    code: "TZS",
    name: "Tanzanian Shilling",
    flag: "https://flagcdn.com/tz.svg",
  },
  {
    code: "UAH",
    name: "Ukrainian Hryvnia",
    flag: "https://flagcdn.com/ua.svg",
  },
  { code: "UGX", name: "Ugandan Shilling", flag: "https://flagcdn.com/ug.svg" },
  { code: "UYU", name: "Uruguayan Peso", flag: "https://flagcdn.com/uy.svg" },
  { code: "UZS", name: "Uzbekistani Som", flag: "https://flagcdn.com/uz.svg" },
  { code: "VND", name: "Vietnamese Dong", flag: "https://flagcdn.com/vn.svg" },
  {
    code: "XAF",
    name: "Central African CFA Franc",
    flag: "https://flagcdn.com/cf.svg",
  },
  {
    code: "XOF",
    name: "West African CFA Franc",
    flag: "https://flagcdn.com/sn.svg",
  },
  {
    code: "ZAR",
    name: "South African Rand",
    flag: "https://flagcdn.com/za.svg",
  },
  { code: "ZMW", name: "Zambian Kwacha", flag: "https://flagcdn.com/zm.svg" },
];

const formatNumber = (value: number | string) => {
  const n = typeof value === "number" ? value : Number(value || 0);
  return new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 6,
  }).format(n);
};

const CurrencyConverter = () => {
  const [amount, setAmount] = useState<number>(100);
  const [base, setBase] = useState<string>("NGN");
  const [displayCurrency, setDisplayCurrency] = useState<string>("USD");
  const [convertedAmount, setConvertedAmount] = useState<number | null>(null);
  const [rate, setRate] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [displayOpen, setDisplayOpen] = useState(false);
  const selected = BASE_CURRENCIES.find((c) => c.code === base);
  const selectedDisplay = BASE_CURRENCIES.find(
    (c) => c.code === displayCurrency,
  );

  const [trigger, { data, isFetching, isError }] =
    useLazyGetCurrencyDetailsQuery();

  const canConvert =
    amount > 0 &&
    base !== "" &&
    displayCurrency !== "" &&
    base !== displayCurrency;

  const debounceTimer = useRef<number | null>(null);

  useEffect(() => {
    if (!canConvert) return;

    if (debounceTimer.current) window.clearTimeout(debounceTimer.current);

    debounceTimer.current = window.setTimeout(async () => {
      try {
        const response = await trigger({
          sourceCurrency: base,
          destinationCurrency: displayCurrency,
          amount,
        }).unwrap();

        console.log("CONVERSION RESPONSE 👉", response);

        setConvertedAmount(response.payload.convertedAmount);
        setRate(response.payload.rate);
      } catch (error) {
        console.error("CONVERSION ERROR ❌", error);
        setConvertedAmount(null);
      }
    }, 500);

    return () => {
      if (debounceTimer.current) window.clearTimeout(debounceTimer.current);
    };
  }, [canConvert, amount, base, displayCurrency, trigger]);

    useEffect(() => {
    document.title = "Currency Converter Page";
  }, []);

  // Use API details for destination dropdown
  const details = data ? [data] : []; // wrap response in array to mimic details

  const usdDetail = useMemo(
    () => details.find((d: any) => d.currency === "USD"),
    [details],
  );

  const selectedDetail = useMemo(
    () => details.find((d: any) => d.currency === displayCurrency),
    [details, displayCurrency],
  );

  const destinationOptions: CurrencyOption[] = useMemo(() => {
    const opts = BASE_CURRENCIES.filter((c) => c.code !== base);

    // make sure displayCurrency is valid
    if (opts.length && !opts.find((o) => o.code === displayCurrency)) {
      setDisplayCurrency(opts[0].code);
    }

    return opts;
  }, [base, displayCurrency]);

  const timestamp = useMemo(() => new Date().toUTCString(), [usdDetail, base]);

  return (
    <DashboardLayout pageTitle="Currency Converter & Trends">
      <p style={{ color: "#45556C" }}>
        Manage exchange rates and analyze market fluctuations.
      </p>
      <div className="w-full min-h-[calc(100vh-80px)] bg-[#ffffff] p-6">
        <div className="max-w-5xl mx-auto">
          <div className="rounded-2xl border border-gray-200 bg-white/60 shadow-sm p-4 md:p-6">
            <p style={{ fontWeight: "700" }}>Conversion Tool</p>
            {/* Banner */}
            <div className="flex justify-between gap-4 p-4 md:p-6">
              <div className="w-72">
                <label className="block text-sm text-gray-600 mb-2">
                  Amount
                </label>
                <div className="flex gap-3 items-center">
                  <input
                    type="number"
                    className="flex-1 h-12 rounded-lg border border-gray-300 px-4 outline-none focus:ring-2 focus:ring-gray-300 bg-white"
                    value={amount}
                    onChange={(e) =>
                      setAmount(Math.max(0, Number(e.target.value)))
                    }
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-2">From</label>
                <div className="h-12">
                  <div className="relative w-72">
                    {/* Selected */}
                    <button
                      onClick={() => setOpen(!open)}
                      className="flex items-center justify-between h-12 w-full rounded-lg border border-gray-300 bg-white px-3"
                    >
                      <div className="flex items-center gap-2">
                        <img
                          src={selected?.flag}
                          alt=""
                          className="w-8 h-8 rounded-full"
                        />
                        <span>{selected?.code}</span>
                      </div>
                      <span>▾</span>
                    </button>

                    {/* Dropdown */}
                    {open && (
                      <ul className="absolute z-10 mt-1 w-full rounded-lg border bg-white shadow max-h-72 overflow-scroll">
                        {BASE_CURRENCIES.map((c) => (
                          <li
                            key={c.code}
                            onClick={() => {
                              setBase(c.code);
                              setOpen(false);
                            }}
                            className="flex cursor-pointer items-center gap-2 px-3 py-2 hover:bg-gray-100"
                          >
                            <img
                              src={c.flag}
                              alt=""
                              className="w-8 h-8 rounded-full"
                            />
                            <span className="font-medium">{c.code}</span>
                            <span className="text-sm text-gray-500">
                              {c.name}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-end">
                <img
                  src={ButImg}
                  alt="Interchange"
                  className="w-8 pb-3 cursor-pointer"
                  onClick={() => {
                    const swipe1 = displayCurrency;
                    const swipe2 = base;
                    setBase(swipe1);
                    setDisplayCurrency(swipe2);
                  }}
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-2">To</label>
                <div className="relative w-72">
                  {/* Selected */}
                  <button
                    onClick={() => setDisplayOpen(!displayOpen)}
                    className="flex items-center justify-between h-12 w-full rounded-lg border border-gray-300 bg-white px-3"
                  >
                    <div className="flex items-center gap-2">
                      <img
                        src={selectedDisplay?.flag}
                        alt=""
                        className="w-8 h-8 rounded-full"
                      />
                      <span>{selectedDisplay?.code}</span>
                    </div>
                    <span>▾</span>
                  </button>

                  {/* Dropdown */}
                  {displayOpen && (
                    <ul className="absolute z-10 mt-1 w-full rounded-lg border bg-white shadow max-h-72 overflow-y-auto">
                      {destinationOptions.map((o) => (
                        <li
                          key={o.code}
                          onClick={() => {
                            setDisplayCurrency(o.code);
                            setDisplayOpen(false);
                          }}
                          className="flex cursor-pointer items-center gap-2 px-3 py-2 hover:bg-gray-100"
                        >
                          <img
                            src={o.flag}
                            alt=""
                            className="w-8 h-8 rounded-full"
                          />
                          <span className="font-medium">{o.code}</span>
                          <span className="text-sm text-gray-500">
                            {o.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {isFetching && (
              <div className="rounded-xl bg-white border border-gray-100 p-4 md:p-6 mb-4">
                <p className="text-xs text-gray-500 mt-2">
                  Fetching latest rates…
                </p>
              </div>
            )}
            {isError && (
              <div className="rounded-xl bg-white border border-gray-100 p-4 md:p-6 mb-4">
                <p className="text-xs text-red-600 mt-2">
                  Failed to load rates. Please try again.
                </p>
              </div>
            )}
            {/* Result & Destination */}
            <div className="rounded-xl bg-white border border-gray-100 p-4 md:p-6 flex justify-between items-center flex-row">
              <div className="flex items-start gap-3 flex-col">
                <p className="text-3xl md:text-4xl font-semibold text-gray-700 flex-1">
                  {convertedAmount !== null
                    ? `${formatNumber(convertedAmount)}${" "}${displayCurrency}${" "}${" "}= ${" "}${" "}${formatNumber(amount)}${" "}${base}`
                    : formatNumber(
                        selectedDetail?.payload.convertedAmount || 0,
                      )}
                </p>

                <div className="text-xs text-gray-500">
                  Last Updated: {timestamp}
                </div>
              </div>
              <div
                className="flex justify-between items-start flex-col p-8 rounded-lg gap-3"
                style={{ background: "#E0E7FF" }}
              >
                <p>Live Rate</p>
                <p className="text-xl md:text-4xl font-semibold text-gray-700">
                  1 {BASE_CURRENCIES.find((c) => c.code === base)?.code} ={" "}
                  {rate !== null
                    ? formatNumber(rate)
                    : formatNumber(
                        selectedDetail?.payload.convertedAmount || 0,
                      )}
                  {displayCurrency !== null
                    ? displayCurrency
                    : selectedDetail?.payload.convertedAmount || 0}
                </p>
                {/* <p
                  className="flex justify-center items-center p-2 py-1 rounded-full gap-1"
                  style={{ background: "#FFE2E2" }}
                >
                  <img src={Downtrend} alt="Downtrend" className="w-4" />
                  <p style={{ color: "#C10007" }}>0.008%</p>
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CurrencyConverter;
